<div class="container px-3 py-3 {{ elemClass }}">
  <ng-content></ng-content>
</div>
